module.exports = __webpack_public_path__ + "assets/6944c077d81b57fdfbe2163f156c4e8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/channels/hu/0.png
// module id = 338
// module chunks = 1